(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosController', StatusAlumnoPlanDeEstudiosController);

    StatusAlumnoPlanDeEstudiosController.$inject = ['StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosController(StatusAlumnoPlanDeEstudios) {

        var vm = this;

        vm.statusAlumnoPlanDeEstudios = [];

        loadAll();

        function loadAll() {
            StatusAlumnoPlanDeEstudios.query(function(result) {
                vm.statusAlumnoPlanDeEstudios = result;
                vm.searchQuery = null;
            });
        }
    }
})();
